export default function PopupArrowSVG() {
	return (
		<svg width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M-4.37114e-07 9L9 0.339744L9 17.6603L-4.37114e-07 9Z" fill="#4C4E4F" />
		</svg>
	);
}
